import { render, staticRenderFns } from "./EvaluationPerformanceCandidatePage.vue?vue&type=template&id=23dca215&"
import script from "./EvaluationPerformanceCandidatePage.vue?vue&type=script&lang=js&"
export * from "./EvaluationPerformanceCandidatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports